import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Script from 'next/script';

// helpers
import { getCurrentPage } from 'src/lib/utils';

const propTypes = {
  'meta-title': PropTypes.string.isRequired,
  'meta-description': PropTypes.string.isRequired,
  hasCanonicalTag: PropTypes.bool,
};

const MetaTags = ({
  'meta-title': metaTitle,
  'meta-description': metaDescription,
  hasCanonicalTag = true,
}) => {
  const { route } = useRouter();
  const currentPage = getCurrentPage(route);

  return (
    <>
      <Head>
        <meta charSet='utf-8' />
        <meta httpEquiv='x-ua-compatible' content='ie=edge' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
        <meta name='msapplication-TileColor' content='#da532c' />
        <meta name='theme-color' content='#ffffff' />
        <meta name='robots' content='noindex, nofollow' />

        {hasCanonicalTag && (
          <link rel='canonical' href={`https://plaid.com${route}/`} />
        )}

        <link
          rel='apple-touch-icon'
          sizes='180x180'
          href='/assets/img/favicons/apple-touch-icon.png'
        />
        <link
          rel='icon'
          type='image/png'
          sizes='32x32'
          href='/assets/img/favicons/favicon-32x32.png'
        />
        <link
          rel='icon'
          type='image/png'
          sizes='16x16'
          href='/assets/img/favicons/favicon-16x16.png'
        />
        <link rel='manifest' href='/assets/img/favicons/site.webmanifest' />
        <link
          rel='mask-icon'
          href='/assets/img/favicons/safari-pinned-tab.svg'
          color='#5bbad5'
        />
        <title>{route !== '/' ? `${metaTitle} - ` : ''}Plaid</title>
        <meta
          property='og:title'
          content={`${route !== '/' ? `${metaTitle} | ` : ''}Plaid`}
        />
        {metaDescription && (
          <>
            <meta name='description' content={metaDescription} />
            <meta property='og:description' content={metaDescription} />
            <meta property='twitter:description' content={metaDescription} />
          </>
        )}

        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content='http://plaid.com/images/open-graph-thumbnail.jpg'
        />

        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:site' content='@plaid' />
        <meta name='twitter:title' content='Plaid' />
        <meta
          name='twitter:image'
          content='http://plaid.com/images/open-graph-thumbnail.jpg'
        />
        <meta
          name='google-site-verification'
          content='koT9reuvekm0hsBjKkf5HAckoBl14cyABQlIVhv-9b8'
        />

        <link rel='stylesheet' href='/assets/css/ios.css' />
        {route.includes('/legal/ios/about') && (
          <link rel='stylesheet' href='/assets/css/ios-about.css' />
        )}
      </Head>

      {/*
        TODO:
        Decouple from jQuery, refactor to React
        [redacted]#############################
      */}
      {currentPage === 'ios' && (
        <Script src='/assets/vendor/ios-privacy-policy-waypoints.js' />
      )}

      {/*
        TODO: Micro optimization, /assets/vendor/clipboard.js could be removed if we make some modifications to Scripts.jsx
      */}
      <Script src='/assets/vendor/clipboard.js' />

      {/*
        TODO: Micro optimization, /assets/js/lib/prism.js could be removed if we make some modifications to Scripts.jsx
      */}
      {/*
        TODO:
        Considering our current application serves this dependency on every page
        It's most expedient to include at the template level rather than including at the component level.
        Ticket to refactor this: [redacted]#############################
      */}
      <Script src='/assets/js/lib/prism.js' />
    </>
  );
};

MetaTags.propTypes = propTypes;
export default MetaTags;
